import React from "react";
import "./style/footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFacebookF,
	faInstagram,
	faWhatsapp,
	faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { LanguageProvider } from "../organisms/language-context";
import dotb from "../../images/dotb.png";

function Footer() {
	const { selectedLanguage, toggleLanguage } = LanguageProvider;

	// const title = selectedLanguage === "english" ? "Contacts" : "Contatti";

	return (
		<footer>
			<div className="footer-container">
				<div className="contact-info">
					<div className="contacts-heading">Contacts</div>
					<div className="contact-item">
						<span>Via Mazzini, 16, Milan, Italy</span>
					</div>
					<div className="contact-item">
						<span>+39 348 351 2992</span>
					</div>
					<div className="contact-item">
						<span>info@bottagioielli.com</span>
					</div>
					<div className="contact-item">
						<span>P. IVA: IT02467180127</span>
					</div>
				</div>
				<div className="social-media">
					<p className="follow-us-text">Follow Us:</p>
					<ul className="social-icons">
						<li>
							<a
								href="https://www.1stdibs.com/dealers/botta-gioielli/"
								target="_blank"
								rel="noreferrer"
								name="dealer_badge_1stdibs_black_and_white"
								className="icon-link"
							>
								<img
									src="https://a.1stdibscdn.com/badges/1stdibs-black_and_white@2x.png"
									alt=""
									border="0"
									width="30"
									height="30"
									className="icon"
								/>
							</a>
						</li>
						<li>
							<a
								href="https://www.instagram.com/bottagioielli/"
								target="_blank"
								className="icon-link"
								rel="noreferrer"
							>
								<FontAwesomeIcon icon={faInstagram} className="icon" />
							</a>
						</li>
						<li>
							<a
								href="https://www.facebook.com/BottaGioielliMilano"
								target="_blank"
								className="icon-link"
								rel="noreferrer"
							>
								<FontAwesomeIcon icon={faFacebookF} className="icon" />
							</a>
						</li>
						<li>
							<a
								href="https://twitter.com/BottaGioielli"
								className="icon-link"
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon icon={faXTwitter} className="icon" />
							</a>
						</li>
						<li>
							<a
								href="https://wa.me/393483512992"
								className="icon-link"
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon icon={faWhatsapp} className="icon" />
							</a>
						</li>
						<li>
							{/* <a href="" className="icon-link">
								<FontAwesomeIcon icon={faPinterest} className="icon" />
							</a> */}
						</li>
						<li>
							<a
								href="https://www.dotbjewels.com/"
								className="icon-link"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src={dotb}
									alt="DotBJewels"
									border="0"
									width="32"
									height="32"
									className="icon"
								/>
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div className="copyright">&copy; Botta Gioielli 2024</div>
		</footer>
	);
}

export default Footer;
